import { Type } from 'class-transformer';
import 'reflect-metadata';
import {ConsentStatus} from './consent-status';

export type DealerInformation = {
  allDealerList: DealerWithGroup[];
}

export class CustomerClientResponse {
  name: string;

  @Type(() => ContactEvent)
  contactEventList: ContactEvent[];

  @Type(() => ContactEvent)
  contactChannelList: ContactEvent[];

  toyota: boolean;
  lexus: boolean;

  @Type(() => Dealer)
  preferredDealer: Dealer;

  @Type(() => Dealer)
  preferredDealerLexus: Dealer;

  @Type(() => Dealer)
  groupDealerList: Dealer[];

  @Type(() => Dealer)
  connectedDealerList: Dealer[];

  @Type(() => DealerWithGroup)
  allDealerList: DealerWithGroup[];

  @Type(() => DealerWithGroup)
  allDealerListLexus: DealerWithGroup[];

  @Type(() => Dealer)
  requestingDealer: Dealer;

  consentVersion: string;
  latestConsentVersion: string;

  events: ConsentStatus;
  offers: ConsentStatus;
  surveys: ConsentStatus;
  reminder: ConsentStatus;
  post: ConsentStatus;
  email: ConsentStatus;
  phone: ConsentStatus;
  messenger: ConsentStatus;

  dataSharing: ConsentStatus;
  profiling: ConsentStatus;
}

export class Customer {
  toyota: boolean;
  lexus: boolean;
}

export class ContactEvent {
  eventName: string;
  displayName: string;
  tooltip: string;
  customerDescription: string;
}

export class DealerWithGroup {
  dealerNumber: string;
  name: string;
  street: string;
  postcode: string;
  city: string;
  dealerGroup: string;
  groupName: string;
  fullCompanyName: string;
  fullCompanyNameAsList: string[];
  toyota: boolean;
  lexus: boolean;
}

export class Dealer {
  dealerNumber: string;
  dealerGroup: string;
  name: string;
  street: string;
  postcode: string;
  city: string;
  fullCompanyName: string;
  fullCompanyNameAsList: string[];
  groupName: string;
  toyota: boolean;
  lexus: boolean;

  static createDealerWithGroup(dealerWithGroup: DealerWithGroup) {
    const dealer = new Dealer();
    dealer.dealerNumber = dealerWithGroup.dealerNumber;
    dealer.name = dealerWithGroup.name;
    dealer.postcode = dealerWithGroup.postcode;
    dealer.street = dealerWithGroup.street;
    dealer.city = dealerWithGroup.city;
    dealer.fullCompanyName = dealerWithGroup.fullCompanyName || '';
    return dealer;
  }

  static create(name: string, dealerNumber: string) {
    const dealer = new Dealer();

    dealer.dealerNumber = dealerNumber;
    dealer.name = name;
    return dealer;
  }
}
